import { render, staticRenderFns } from "./PaginaCostoSpettacolo.vue?vue&type=template&id=2a855314"
import script from "./PaginaCostoSpettacolo.vue?vue&type=script&lang=js"
export * from "./PaginaCostoSpettacolo.vue?vue&type=script&lang=js"
import style0 from "./PaginaCostoSpettacolo.vue?vue&type=style&index=0&id=2a855314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports